/** @format */

// import { MoreOutlined } from "@ant-design/icons";
import { Card, Table } from "antd";
import { useState } from "react";
import { formatCurr } from "utils/helper";

type CardTableProps = {
  title: string;
  data: any[];
  loading?: boolean;
  type:
    | "snp"
    | "rencana"
    | "realisasi"
    | "detailMadrasah"
    | "detailLokasi"
    | "detailLokasiIndikatif";
};

const getColumns = (pagination: { current: number; pageSize: number }) => [
  {
    type: "snp",
    column: [
      {
        title: "Standar Nasional Pendidikan",
        dataIndex: "namaSnp",
        key: "namaSnp",
      },
      {
        title: "Rencana Belanja",
        dataIndex: "rencanaBelanja",
        key: "rencanaBelanja",
        render: (rencanaBelanja) => formatCurr(rencanaBelanja) || 0,
      },
      {
        title: "%",
        dataIndex: "rencanaBelanjaPercentage",
        key: "rencanaBelanjaPercentage",
        render: (rencanaBelanjaPercentage) =>
          rencanaBelanjaPercentage
            ? `${rencanaBelanjaPercentage.toFixed(2)}%`
            : "0%",
      },
      {
        title: "Realisasi Belanja",
        dataIndex: "realisasiBelanja",
        key: "realisasiBelanja",
        render: (realisasiBelanja) => formatCurr(realisasiBelanja) || 0,
      },
      {
        title: "%",
        dataIndex: "realisasiBelanjaPercentage",
        key: "realisasiBelanjaPercentage",
        render: (realisasiBelanjaPercentage) =>
          realisasiBelanjaPercentage
            ? `${realisasiBelanjaPercentage.toFixed(2)}%`
            : "0%",
      },
      {
        title: "Rasio",
        dataIndex: "rasioSnpPercentage",
        key: "rasioSnpPercentage",
        render: (rasioSnpPercentage) =>
          rasioSnpPercentage ? `${rasioSnpPercentage.toFixed(2)}%` : "0%",
      },
    ],
  },
  {
    type: "rencana",
    column: [
      {
        title: "Provinsi",
        dataIndex: "namaProvinsi",
        key: "namaProvinsi",
      },
      {
        title: "Kabupaten/Kota",
        dataIndex: "namaKabKota",
        key: "namaKabKota",
      },
      {
        title: "Madrasah",
        dataIndex: "namaMadrasah",
        key: "namaMadrasah",
      },
      {
        title: "NSM",
        dataIndex: "nsm",
        key: "nsm",
      },
      {
        title: "Rencana Pendapatan",
        dataIndex: "anggaranPendapatan",
        key: "anggaranPendapatan",
        render: (anggaranPendapatan) => formatCurr(anggaranPendapatan) || 0,
        align: "right" as const,
      },
      {
        title: "Rencana Belanja",
        dataIndex: "anggaranBelanja",
        key: "anggaranBelanja",
        render: (anggaranBelanja) => formatCurr(anggaranBelanja) || 0,
        align: "right" as const,
      },
    ],
  },
  {
    type: "rencanaIndikatif",
    column: [
      {
        title: "Provinsi",
        dataIndex: "namaProvinsi",
        key: "namaProvinsi",
      },
      {
        title: "Kabupaten/Kota",
        dataIndex: "namaKabKota",
        key: "namaKabKota",
      },
      {
        title: "Madrasah",
        dataIndex: "namaMadrasah",
        key: "namaMadrasah",
      },
      {
        title: "NSM",
        dataIndex: "nsm",
        key: "nsm",
      },
      {
        title: "Rencana Pendapatan",
        dataIndex: "rencanaPendapatan",
        key: "rencanaPendapatan",
        render: (rencanaPendapatan) => formatCurr(rencanaPendapatan) || 0,
        align: "right" as const,
      },
      {
        title: "Rencana Belanja",
        dataIndex: "rencanaBelanja",
        key: "rencanaBelanja",
        render: (rencanaBelanja) => formatCurr(rencanaBelanja) || 0,
        align: "right" as const,
      },
    ],
  },
  {
    type: "realisasi",
    column: [
      {
        title: "Provinsi",
        dataIndex: "namaProvinsi",
        key: "namaProvinsi",
      },
      {
        title: "Kabupaten/Kota",
        dataIndex: "namaKabKota",
        key: "namaKabKota",
      },
      {
        title: "Madrasah",
        dataIndex: "namaMadrasah",
        key: "namaMadrasah",
      },
      {
        title: "NSM",
        dataIndex: "nsm",
        key: "nsm",
      },
      {
        title: "Realisasi Pendapatan",
        dataIndex: "realisasiPendapatan",
        key: "realisasiPendapatan",
        render: (realisasiPendapatan) => formatCurr(realisasiPendapatan) || 0,
        align: "right" as const,
      },
      {
        title: "Realisasi Belanja",
        dataIndex: "realisasiBelanja",
        key: "realisasiBelanja",
        render: (realisasiBelanja) => formatCurr(realisasiBelanja) || 0,
        align: "right" as const,
      },
    ],
  },
  {
    type: "detailMadrasah",
    column: [
      {
        title: "Nama Madrasah",
        dataIndex: "nama",
        key: "nama",
      },
      {
        title: "NSM",
        dataIndex: "nsm",
        key: "nsm",
      },
      {
        title: "Anggaran Pendapatan",
        dataIndex: "anggaranPendapatan",
        key: "anggaranPendapatan",
        render: (anggaranPendapatan) => formatCurr(anggaranPendapatan) || 0,
        align: "right" as const,
      },
      {
        title: "Realisasi Pendapatan",
        dataIndex: "realisasiPendapatan",
        key: "realisasiPendapatan",
        render: (realisasiPendapatan) => formatCurr(realisasiPendapatan) || 0,
        align: "right" as const,
      },
      {
        title: "Anggaran Belanja",
        dataIndex: "anggaranBelanja",
        key: "anggaranBelanja",
        render: (anggaranBelanja) => formatCurr(anggaranBelanja) || 0,
        align: "right" as const,
      },
      {
        title: "Realisasi Belanja",
        dataIndex: "realisasiBelanja",
        key: "realisasiBelanja",
        render: (realisasiBelanja) => formatCurr(realisasiBelanja) || 0,
        align: "right" as const,
      },
      {
        title: "Anggaran Sisa",
        key: "anggaranSisa",
        render: (_, record) =>
          formatCurr(record?.anggaranPendapatan - record?.RencanaBelanja) || 0,
        align: "right" as const,
      },
      {
        title: "Realisasi Sisa",
        key: "realisasiSisa",
        render: (_, record) =>
          formatCurr(record?.realisasiPendapatan - record?.realisasiBelanja) ||
          0,
        align: "right" as const,
      },
    ],
  },
  {
    type: "detailLokasi",
    column: [
      {
        title: "",
        key: "no",
        render: (_, __, index) =>
          (pagination.current - 1) * pagination.pageSize + index + 1,
      },
      {
        title: "Nama",
        dataIndex: "namaDaerah",
        key: "namaDaerah",
      },
      {
        title: "Rencana Selesai",
        dataIndex: "rencanaSelesai",
        key: "rencanaSelesai",
        render: (rencanaSelesai) => formatCurr(rencanaSelesai) || 0,
        align: "right" as const,
      },
      {
        title: "Rencana Belum Selesai",
        dataIndex: "rencanaBelumSelesai",
        key: "rencanaBelumSelesai",
        render: (rencanaBelumSelesai) => formatCurr(rencanaBelumSelesai) || 0,
        align: "right" as const,
      },
      {
        title: "Realisasi Selesai",
        dataIndex: "realisasiSelesai",
        key: "realisasiSelesai",
        render: (realisasiSelesai) => formatCurr(realisasiSelesai) || 0,
        align: "right" as const,
      },
      {
        title: "Realisasi Belum Selesai ",
        dataIndex: "realisasiBelumSelesai",
        key: "realisasiBelumSelesai",
        render: (realisasiBelumSelesai) =>
          formatCurr(realisasiBelumSelesai) || 0,
        align: "right" as const,
      },
    ],
  },
  {
    type: "detailLokasiIndikatif",
    column: [
      {
        title: "",
        key: "no",
        render: (_, __, index) =>
          (pagination.current - 1) * pagination.pageSize + index + 1,
      },
      {
        title: "Nama",
        dataIndex: "namaDaerah",
        key: "namaDaerah",
      },
      {
        title: "Rencana Selesai",
        dataIndex: "rencanaSelesai",
        key: "rencanaSelesai",
        render: (rencanaSelesai) => formatCurr(rencanaSelesai) || 0,
        align: "right" as const,
      },
      {
        title: "Rencana Belum Selesai",
        dataIndex: "rencanaBelumSelesai",
        key: "rencanaBelumSelesai",
        render: (rencanaBelumSelesai) => formatCurr(rencanaBelumSelesai) || 0,
        align: "right" as const,
      },
    ],
  },
];

export const CardTable = ({ title, data, type, loading }: CardTableProps) => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const columns =
    getColumns(pagination).find((col) => col.type === type)?.column || [];

  return (
    <Card title={title} headStyle={{ fontWeight: "bold" }}>
      <Table
        rowKey={(record, index) =>
          record.id || record.nsm || index || Math.random()
        }
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
        }}
        onChange={(pag) => {
          setPagination({
            current: pag.current || 1,
            pageSize: pag.pageSize || 10,
          });
        }}
      />
    </Card>
  );
};

type TableDetailProps = {
  title: string;
  data: any;
  pagination: any;
  loading?: boolean;
  type: "rencana" | "realisasi" | "rencanaIndikatif";
  handlePageChange: (page: number, pageSize: number) => void;
};

export const TableDetail = ({
  title,
  data,
  pagination,
  type,
  loading,
  handlePageChange,
}: TableDetailProps) => {
  const columns =
    getColumns(pagination).find((col) => col.type === type)?.column || [];

  const listData = data?.content || [];

  return (
    <Table
      rowKey={(record, index) => `${record.nsm}-${pagination.current}-${index}`}
      columns={columns}
      dataSource={listData}
      loading={loading}
      pagination={{
        current: pagination?.current,
        pageSize: pagination?.pageSize,
        total: data?.totalElements || 0,
        position: ["bottomRight"],
        showTotal: () => `Total ${data?.totalElements || 0} items`,
        onChange: (page, pageSize) => {
          handlePageChange(page, pageSize);
        },
      }}
    />
  );
};
